import React, { useState } from 'react';

const HashtagDisplay = ({ hashtags = [], maxVisible = 3, className = '', onHashtagClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Return early if no hashtags
  if (!hashtags || hashtags.length === 0) {
    return null;
  }

  // Color variants for hashtags - using your theme colors
  const colorVariants = [
    'bg-primary/10 text-primary border-primary/20',
    'bg-secondary/10 text-secondary border-secondary/20',
    'bg-info/10 text-info border-info/20',
    'bg-warning/10 text-warning border-warning/20',
    'bg-success/10 text-success border-success/20',
    'bg-gray-100 text-gray-700 border-gray-200',
  ];

  // Function to get color for a hashtag based on its content
  const getHashtagColor = (hashtag, index) => {
    // Use a simple hash function to consistently assign colors
    const hash = hashtag.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colorVariants[hash % colorVariants.length];
  };

  const handleHashtagClick = (hashtag, event) => {
    event.stopPropagation(); // Prevent event bubbling
    if (onHashtagClick) {
      onHashtagClick(hashtag);
    }
  };

  const visibleHashtags = isExpanded ? hashtags : hashtags.slice(0, maxVisible);
  const hasMore = hashtags.length > maxVisible;
  const remainingCount = hashtags.length - maxVisible;

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {visibleHashtags.map((hashtag, index) => {
        const baseClasses = `inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full border transition-all duration-200 ${getHashtagColor(hashtag, index)}`;
        const clickableClasses = onHashtagClick ? 'cursor-pointer hover:shadow-md hover:scale-105' : 'hover:shadow-sm';
        
        return onHashtagClick ? (
          <button
            key={`${hashtag}-${index}`}
            onClick={(e) => handleHashtagClick(hashtag, e)}
            className={`${baseClasses} ${clickableClasses}`}
            title={`Filter by ${hashtag}`}
          >
            {hashtag}
          </button>
        ) : (
          <span
            key={`${hashtag}-${index}`}
            className={`${baseClasses} ${clickableClasses}`}
          >
            {hashtag}
          </span>
        );
      })}
      
      {hasMore && !isExpanded && (
        <button
          onClick={() => setIsExpanded(true)}
          className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full border transition-all duration-200 hover:shadow-sm bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
        >
          +{remainingCount} more
        </button>
      )}
      
      {isExpanded && hasMore && (
        <button
          onClick={() => setIsExpanded(false)}
          className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full border transition-all duration-200 hover:shadow-sm bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
        >
          show less
        </button>
      )}
    </div>
  );
};

export default HashtagDisplay;
